import Image from 'next/image';

import { Heading, Page, Paragraph } from '@zillow/constellation-10';

import { FOR_SALE_ILLUSTRATION_URL } from '../../constants/DigitalLibraryConstants';

export const CLPLoadingState = ({ isNewProperty = false }: { isNewProperty?: boolean }) => {
  const heading = isNewProperty ? 'Setting up your listing' : 'Picking up where you left off';
  const subheading = isNewProperty
    ? 'One moment while we get things ready.'
    : 'One moment while we load your progress.';

  return (
    <Page.Root
      css={{
        height: '100vh',
        backgroundColor: 'bg.neutral',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Image priority width={120} height={120} src={FOR_SALE_ILLUSTRATION_URL} alt="" role="presentation" />
      <Heading level={1} textStyle="heading-sm">
        {heading}
      </Heading>
      <Paragraph textStyle="body-sm">{subheading}</Paragraph>
    </Page.Root>
  );
};
